module.exports = __webpack_public_path__ + "img/logo-white.6bf82072.svg";